module.exports = __webpack_public_path__ + "static/media/trimex_euskaro.eff35c57.png";